<template>
  <div class="boxContactForm">
    <b-form
      @submit.prevent="submitContactForm"
      method="post"
      class="contact-form"
      style="text-align: left"
      ref="contactForm"
      v-if="show"
    >
      <!-- FORM HEADER -->
      <h2 class="form-header-h2">Send Your Message</h2>
      <div>
        <p>
          Your message is private and will not be visible here or to other
          users.
        </p>
      </div>
      <!-- FULLNAME INPUT -->
      <b-input-group>
        <span class="formIcons">
          <UserIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="name-input-1"
          ref="nameInput"
          name="name-input-1"
          size="lg"
          placeholder="NAME"
          v-model="$v.form.name.$model"
          :state="validateState('name')"
          aria-describedby="input-1-name-feedback"
          disabled
        ></b-form-input>

        <b-form-invalid-feedback id="input-1-name-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- EMAIL INPUT -->
      <b-input-group>
        <span class="formIcons email">
          <EmailIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="email-input-2"
          name="email-input-2"
          size="lg"
          placeholder="E-MAIL"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          aria-describedby="input-2-email-feedback"
          disabled
        ></b-form-input>

        <b-form-invalid-feedback id="input-2-email-feedback"
          >This is a required field and must be a valid
          e-mail.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- SUBJECT INPUT -->
      <b-input-group>
        <span class="formIcons subject">
          <SubjectIcon />
        </span>
        <b-form-input
          class="input-box-area"
          id="subject-input-3"
          name="subject-input-3"
          size="lg"
          placeholder="SUBJECT"
          v-model="$v.form.subject.$model"
          :state="validateState('subject')"
          aria-describedby="input-3-subject-feedback"
        ></b-form-input>

        <b-form-invalid-feedback id="input-3-subject-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <!-- MESSAGE INPUT -->
      <b-input-group>
        <span class="formIcons message">
          <MessageIcon />
        </span>
        <b-form-textarea
          class="input-box-area textarea-box-area"
          id="message-input-4"
          name="message-input-4"
          size="lg"
          rows="6"
          placeholder="MESSAGE"
          v-model="$v.form.message.$model"
          :state="validateState('message')"
          aria-describedby="input-4-message-feedback"
        ></b-form-textarea>

        <b-form-invalid-feedback id="input-4-message-feedback"
          >This is a required field and must be at least 3
          characters.</b-form-invalid-feedback
        >
      </b-input-group>

      <div class="toast-container">
        <b-toast
          title="Thank You!"
          id="messageSent"
          variant="success"
          static
          solid
          auto-hide-delay="7000"
          no-close-button
        >
          {{ FormWasSentMessage }}
        </b-toast>
        <b-toast
          title="Sorry!"
          id="messageNotSent"
          variant="danger"
          static
          solid
          auto-hide-delay="7000"
          no-close-button
        >
          {{ FormWasntSentMessage }}
        </b-toast>
      </div>

      <button class="button-contact-form" type="submit" id="submitButton">
        <b-spinner small v-show="showLoad"></b-spinner>
        <span class id="button-text" v-if="!showLoad">SUBMIT</span>
      </button>
    </b-form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { email, required, minLength } from "vuelidate/lib/validators";
import { BACKEND_URL } from "@/config.js";
import UserIcon from "@/components/icons/UserIcon.vue";
import EmailIcon from "@/components/icons/EmailIcon.vue";
import SubjectIcon from "@/components/icons/SubjectIcon.vue";
import MessageIcon from "@/components/icons/MessageIcon.vue";

export default {
  components: {
    UserIcon,
    EmailIcon,
    SubjectIcon,
    MessageIcon,
  },
  props: ["customerInfo"],
  mixins: [validationMixin],
  data() {
    return {
      form: {
        name:
          JSON.parse(sessionStorage.getItem("customerInfo")).user.firstName +
          " " +
          JSON.parse(sessionStorage.getItem("customerInfo")).user.lastName,
        email: JSON.parse(sessionStorage.getItem("customerInfo")).user.email,
        subject: null,
        message: null,
      },
      show: true,
      showLoad: false,
      FormWasSentMessage:
        "Your message was sent to our support team successfully.",
      FormWasntSentMessage:
        "Sorry, but we were unable to send your message now. Please, try again later.",
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
      },
      email: {
        required,
        email,
      },
      subject: {
        required,
        minLength: minLength(3),
      },
      message: {
        required,
        minLength: minLength(3),
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    submitContactForm() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.showLoad = true;

      let customer = sessionStorage.getItem("customerInfo");
      var jwt = null;
      if (customer) {
        jwt = JSON.parse(customer).token.token;
      }
      let reqHeaders = { "Content-type": "application/json" };
      if (jwt) {
        reqHeaders["Authorization"] = jwt;
      }

      let jsonForm = JSON.stringify(this.form);

      const url = BACKEND_URL.ContactFormMessage;

      console.log("SUBMITING THE FORM " + url);

      fetch(url, {
        method: "POST",
        mode: "cors",
        body: jsonForm,
        headers: reqHeaders,
        cache: "no-cache",
      })
        .then((response) => {
          if (response.ok) {
            this.showLoad = false;
            this.$bvToast.show("messageSent");
          } else {
            this.showLoad = false;
            this.$bvToast.show("messageNotSent");
            throw Error(response.status + ": " + response.statusText);
          }
        })
        .catch((error) => {
          this.showLoad = false;
          console.error(error);
        });

      // Reset some form values
      this.form.subject = null;
      this.form.message = null;
      // Reset/clear native browser form validation state
      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
  },
};
</script>

<style scoped lang="scss">
// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

.boxContactForm {
  background-color: #ffffff;
  border: 1px solid #aaaaaa;
  padding: 60px 15px;
  text-align: left;
}

//form header
h2.form-header-h2 {
  color: $color;
  font-size: 24px;
  font-weight: $font-bold;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.formIcons {
  &.subject,
  &.message {
    svg {
      width: 19px;
      margin-left: 20px;
    }
  }
}

.input-box-area {
  background: $bg-input;
  background-image: none;
  border: $border-input;
  border-radius: 6px;
  color: $color-input;
  font-size: $font-size-input;
  height: auto;
  line-height: $line-height-input;
  padding: $padding-input;
  resize: none;

  &:focus {
    background-color: #ffffff;
    border: 1px solid #dcdcdc;
  }
}

textarea.textarea-box-area {
  border-radius: 6px !important;
}

.button-contact-form {
  background: #79b867;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  width: 100%;
  font-size: 20px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 15px;
  line-height: 25px;
}

.button-contact-form:hover {
  background: #000000;
}

.button-contact-form:active,
.button-contact-form:focus {
  background: #000000 !important;
  color: #ffffff !important;
  border-color: #000000 !important;
  box-shadow: none !important;
  outline: none;
}
.button-contact-form:disabled {
  background: #79b867 !important;
  color: white;
}

.positive-feedback,
.negative-feedback {
  margin-top: 2rem;
  margin-bottom: 0;
  text-align: center;
  font-weight: 600;
}

form .b-toast {
  width: auto;
}

.toast-container {
  display: flex;
  justify-content: center;
  margin: 2rem 0;

  #messageSent.toast,
  #messageNotSent.toast {
    margin: auto;
  }
}

@media screen and (max-width: 767px) {
  form {
    font-size: 16px;
    .input-group {
      input,
      textarea {
        font-size: 16px;
      }
    }
  }
  .button-contact-form {
    font-size: 18px;
  }

  .boxContactForm {
    border: 0;
    padding: 0;
  }
}
</style>
